import { useId } from 'react'
import { Label, Switch } from '@teach/ui'
import type { CourseWithoutBlocks } from '@/types/course'
import { useAppDispatch } from '@/store/hooks'
import { coursesApi, useUpdateCourseMutation } from '../../coursesApi'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  course: CourseWithoutBlocks
  disabled: boolean
}

/**
 * «Показывать в Explore» для курса по ссылке. Курс из каталога виден в Explore
 * всегда, без галочки. Значение — из `showInExplore` детали; пишется в живой курс
 * и в черновик сразу, без проверки (сквозное поле). Оптимистика — в кеше
 * getEditorCourse, провал откатывает патч.
 */
export const ExploreToggle = ({ course, disabled }: Props) => {
  const m = useMessages(messages)
  const id = useId()
  const [updateCourse] = useUpdateCourseMutation()
  const dispatch = useAppDispatch()

  const toggle = (next: boolean) => {
    const patch = dispatch(
      coursesApi.util.updateQueryData('getEditorCourse', course.id, (draft) => {
        draft.showInExplore = next
      }),
    )
    void updateCourse({ id: course.id, patch: { showInExplore: next } })
      .unwrap()
      .catch(() => patch.undo())
  }

  return (
    <div className="flex items-start justify-between gap-3 rounded-xl border border-border p-3">
      <div className="space-y-0.5">
        <Label htmlFor={id} className="text-sm font-medium">
          {m.exploreToggle}
        </Label>
        <p className="text-xs text-muted-foreground">{m.exploreHint}</p>
      </div>
      <Switch
        id={id}
        checked={course.showInExplore ?? false}
        onCheckedChange={toggle}
        disabled={disabled}
      />
    </div>
  )
}
